<template>
    <div>
        <div id="proposal-settings-tab-div" v-if="settingsTypes == 'tabs'">
            <ul class="nav nav-tabs custom-tabs-pg-settings" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="proposals-tab" data-toggle="tab" href="#proposals" role="tab" aria-controls="proposals" aria-selected="true">Proposals</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="sections-tab" data-toggle="tab" href="#sections" role="tab" aria-controls="sections" aria-selected="false">Sections</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="content-groups-tab" data-toggle="tab" href="#content-groups" role="tab" aria-controls="content-groups" aria-selected="false">Section Contents</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="contents-tab" data-toggle="tab" href="#contents" role="tab" aria-controls="contents" aria-selected="false">Content</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="settings-tab" data-toggle="tab" href="#settings" role="tab" aria-controls="settings" aria-selected="false">Settings</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="product-and-services-tab" data-toggle="tab" href="#product-and-services" role="tab" aria-controls="product-and-services" aria-selected="false">Product & Services</a>
                </li>
            </ul>
            <div class="tab-content" id="proposal-settings-tab-content">

                <!--Proposal Template-->
                <div class="tab-pane fade show active" id="proposals" role="tabpanel" aria-labelledby="proposals-tab">
                    <proposal-settings-templates></proposal-settings-templates>
                </div>
                <!--Proposal Template Section-->
                <div class="tab-pane fade" id="sections" role="tabpanel" aria-labelledby="sections-tab">
                    <proposal-settings-sections></proposal-settings-sections>
                </div>
                <!--Proposal Content Group-->
                <div class="tab-pane fade" id="content-groups" role="tabpanel" aria-labelledby="content-groups-tab">
                    <proposal-settings-content-groups></proposal-settings-content-groups>
                </div>
                <!--Proposal Content-->
                <div class="tab-pane fade" id="contents" role="tabpanel" aria-labelledby="contents-tab">
                    <proposal-settings-contents></proposal-settings-contents>
                </div>
                <!--Proposal Setting-->
                <div class="tab-pane fade" id="settings" role="tabpanel" aria-labelledby="settings-tab">
                    <proposal-settings-page :team="team" :base-url="baseUrl" :header-footer-image-upload-url="headerFooterImageUploadUrl"></proposal-settings-page>
                </div>
                <!--Product and services-->
                <div class="tab-pane fade" id="product-and-services" role="tabpanel" aria-labelledby="product-and-services-tab">
                    <proposal-settings-product-and-services-main-tab></proposal-settings-product-and-services-main-tab>
                </div>
            </div>
        </div>
        <div v-if="settingsTypes !== 'tabs'">
            <div class="overflow-hidden ml-3 mb-3" >
                <span class="overflow-hidden cursor-pointer" @click="changeSettingTypesMethod('tabs')">
                    <img :src="baseUrl+'/images/back-arrow-followup.png'" class="proposal-setting-back-arrow float-left pt-1">
                    <span class="text-sm pt-1 float-left display-block">Go back</span>
                </span>
            </div>
            <div class="w-100" v-if="settingsTypes == 'template-manage'">
                <proposal-settings-templates-manage
                    :proposal-template="proposalTemplate"
                    :base-url="baseUrl"
                >
                </proposal-settings-templates-manage>
            </div>
            <div class="w-100" v-if="settingsTypes == 'content-group-manage'">
                <proposal-settings-content-groups-manage
                    :proposal-content-group="contentGroupManage"
                    :base-url="baseUrl"
                >
                </proposal-settings-content-groups-manage>
            </div>
            <div class="w-100" v-if="settingsTypes == 'content-pdf-manage'">
                <proposal-settings-content-pdf-manage
                    :proposal-content-pdf="contentPDFManage"
                >
                </proposal-settings-content-pdf-manage>
            </div>
            <div class="w-100" v-if="settingsTypes == 'content-text-manage'">
                <proposal-settings-content-text-manage
                    :proposal-content-text="contentTextManage"
                    :role="role"
                >
                </proposal-settings-content-text-manage>
            </div>
            <div class="w-100" v-if="settingsTypes == 'content-sheet-manage'">
                <proposal-settings-content-sheet-manage
                    :proposal-content-sheet="contentSheetManage"
                >
                </proposal-settings-content-sheet-manage>
            </div>
            <div class="w-100" v-if="settingsTypes == 'template-settings'">
                <proposal-settings-template-settings
                    :proposal-template="proposalTemplate"
                    :base-url="baseUrl"
                    :team="team"
                    :header-footer-image-upload-url="headerFooterImageUploadUrl"
                    :user="user"
                >
                </proposal-settings-template-settings>
            </div>
            <div class="w-100" v-if="settingsTypes == 'content-quote-and-pricing-template'">
                <pg-quote-pricing-template-setting
                    :proposal-template="proposalTemplate"
                    :base-url="baseUrl"
                >
                </pg-quote-pricing-template-setting>
            </div>
        </div>
    </div>
</template>

<script>

import ProposalSettingsTemplates from "./proposal-settings-templates";
import ProposalSettingsTemplatesManage from "./proposal-settings-templates-manage";
import ProposalSettingsSection from "./proposal-settings-sections";
import ProposalSettingsContentGroups from "./proposal-settings-content-groups";
import ProposalSettingsPage from "./proposal-settings-page";
import ProposalSettingsTemplateSettings from "./proposal-settings-template-settings.vue";
import ProposalSettingsProductAndServicesMainTab
    from "./quote-pricing/proposal-settings-product-and-services-main-tab.vue";
import ProposalSettingsContents from "./proposal-settings-contents.vue";
import ProposalSettingsSections from "./proposal-settings-sections.vue";
import PgQuotePricingTemplateSetting from "./quote-pricing/pg-quote-pricing-template-setting.vue";
export default {
    name: "proposal-settings-tab-page",
    props:['team', 'headerFooterImageUploadUrl', 'role', 'user'],
    components: {
        PgQuotePricingTemplateSetting,
        ProposalSettingsSections,
        ProposalSettingsContents,
        ProposalSettingsProductAndServicesMainTab,
        ProposalSettingsTemplateSettings,
        ProposalSettingsPage,
        ProposalSettingsContentGroups,
        ProposalSettingsTemplatesManage, ProposalSettingsTemplates, ProposalSettingsSection},
    data() {
        return {
            settingsTypes:'tabs',
            baseUrl:window.location.origin,
            proposalTemplate: null,
            contentGroupManage: null,
            contentPDFManage: null,
            contentTextManage: null,
            contentSheetManage: null,
            prizmEditorBaseURL: null,
            prizmSheetBaseURL: null,
            lastTab:null
        }
    },
    mounted(){
        this.prizmEditorBaseURL = process.env.MIX_PRIZM_EDITOR_URL;
        let ScriptEditor = document.createElement("script");
        ScriptEditor.setAttribute("src", this.prizmEditorBaseURL+"interface.js");
        document.head.appendChild(ScriptEditor);

        this.prizmSheetBaseURL = process.env.MIX_PRIZM_SHEET_URL;
        let ScriptSheet = document.createElement("script");
        ScriptSheet.setAttribute("src", this.prizmSheetBaseURL+"clientControl/interface.js");
        document.head.appendChild(ScriptSheet);

        Bus.$on('changeSettingType', data => {
            this.assignProp(data.selectedData, data.type);
            this.changeSettingTypesMethod(data.type);
        });
    },
    methods: {
        changeSettingTypesMethod(type){
            this.settingsTypes = type;
            if(type == 'tabs'){
                this.goToLastTab();
            }
        },
        assignProp(selectedData, type){
            if(type == 'template-manage'){
                this.proposalTemplate = selectedData;
                this.lastTab = 'proposals-tab';
            }else if(type == 'content-group-manage'){
                this.contentGroupManage = selectedData;
                this.lastTab = 'content-groups-tab';
            }else if(type == 'content-pdf-manage'){
                this.contentPDFManage = selectedData;
                this.lastTab = 'contents-tab';
            }else if(type == 'content-text-manage'){
                this.contentTextManage = selectedData;
                this.lastTab = 'contents-tab';
            }else if(type == 'content-sheet-manage'){
                this.contentSheetManage = selectedData;
                this.lastTab = 'contents-tab';
            }else if(type == 'template-settings'){
                this.proposalTemplate = selectedData;
                this.lastTab = 'proposals-tab';
            }else if(type == 'content-quote-and-pricing-template'){
                this.proposalTemplate = selectedData;
                this.lastTab = 'contents-tab';
            }else{
                this.contentGroupManage = null;
                this.contentPDFManage = null;
                this.contentTextManage = null;
                this.contentSheetManage = null;
                this.proposalTemplate = null;
                this.lastTab = null;
            }
        },
        goToLastTab(){
            this.$nextTick(() => {
                $('#proposal-settings-tab-div .nav-link').removeClass('active');
                $('#proposal-settings-tab-content .tab-pane').removeClass('show');
                $('#proposal-settings-tab-content .tab-pane').removeClass('active');
                $('#'+this.lastTab).addClass('active');
                $('[aria-labelledby="'+this.lastTab+'"]').addClass('show');
                $('[aria-labelledby="'+this.lastTab+'"]').addClass('active');
            });
        }
    }
};
</script>

<style>
#proposal-settings-tab-div .custom-tabs-pg-settings .nav-link.active,
#proposal-settings-tab-div .custom-tabs-pg-settings .nav-link:hover,
#proposal-settings-tab-div .custom-tabs-pg-settings .nav-link:focus{
    background-color: #ffffff !important;
    border-bottom-color: transparent !important;
    color: #555;
}
#proposal-settings-tab-content {
    padding: 15px;
    border: 1px solid #c7cdd1;
    border-top: 0;
    border-radius: 0 0 5px 5px;
    min-height: 60vh;
    background: #fff;
}
#proposal-settings-tab-div .nav-item a {
    font-weight: 300;
}
.proposal-setting-back-arrow{
    width:20px;
}
</style>
